import { render, staticRenderFns } from "./DetailUser.vue?vue&type=template&id=232efd36&scoped=true&"
import script from "./DetailUser.vue?vue&type=script&lang=js&"
export * from "./DetailUser.vue?vue&type=script&lang=js&"
import style0 from "./DetailUser.vue?vue&type=style&index=0&id=232efd36&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232efd36",
  null
  
)

export default component.exports